const _ = require("lodash");
/**
 * Get an array of all of the contiguous color
 * partitions in the strip
 * Each sub-array will begin with the color the
 * partition is filled with, followed by the indices
 * for all of the squares that are filled with that color
 * eg if a strip if filled with [1, 1, 3, 1, 2, 2] then
 * this will return
 * [
 *   [1, 0, 1], // First partition has color 1, and is filling squares at indices 0 and 1
 *   [3, 2], // Second partition has color 3, and is filling square at index 2
 *   [1, 3], // Third partition has color 1, and is filling square at index 3
 *   [2, 4, 5], // Last partition has color 2, and if filling squares at indices 4 and 5
 * ]
 * @param {Array} grid
 * @returns {Array}
 */
const getContiguousSections = function(grid) {
	let currentValue = grid[0];
	const sections = [];

	let currentCell = 0;
	let currentSection = [];

	while (currentCell < grid.length) {
		const thisCellValue = grid[currentCell];

		if (thisCellValue === currentValue) {
			currentSection.push(currentCell);
			currentCell++;
		} else {
			// If the value is 0, that means the cell is empty, and this cell
			// isn't part of a contiguous section of squares filled-in by the user
			// so we don't include it. This lets us use the number of
			// partitions returned by this function to help determine if a
			// submitted answer is correct.
			if (currentValue !== 0) {
				sections.push([currentValue].concat(currentSection));
			}
			currentSection = [];
			currentValue = thisCellValue;
		}
	}

	if (currentSection.length !== 0 && currentValue !== 0) {
		sections.push([currentValue].concat(currentSection));
	}
	return sections;
};

/**
 * Returns the grid, but partitioned into chunks
 * corresponding to the sum terms in the problem model
 * eg if the sum terms are '3' and '5', and the grid looks like this
 * [ 1, 2, 1, 1, 3, 2, 2, 2]
 * then this will return an array, with sub-arrays having 3 and 5 elements
 * each containing the values in the grid:
 * [
 *   [1, 2, 1],
 *   [1, 3, 2, 2, 2],
 * ]
 * @param {Array} grid
 * @param {Array} sumTerms
 * @returns {Array}
 */
const getPartitionedGrid = function(grid, sumTerms) {
	const sections = [];
	let currBox = 0;

	// The summing terms tell us how many squares should be filled in
	// eg ['4', '5', '2'] means we should have 4 squares of one color
	// then 5 squares of a different color, then 2 squares of yet
	// another different color
	// So what we can do is: for each of the summing terms
	// we grab that many squares from the grid, moving
	// down each time we grab new squares, then inspect
	// the result
	_.each(sumTerms, (sTerm, idx) => {
		// We'll grab sTerm number of items from the grid and just save what their values are
		// Later we'll check if they are continuous and unbroken
		const expectedSquares = parseInt(sTerm);
		const thisSectionsSquares = grid.slice(currBox, currBox + expectedSquares);
		// store color for first element
		// use order of sub-array (eg subarray 1, 2, 3) to know
		// what term is to be colored
		// We don't need to store the color because the grid
		// already tells us what color is in each square
		sections.push([...thisSectionsSquares]);
		currBox += expectedSquares;
	});
	return sections;
};

const getValueColors = function() {
	return [
		"pink", // 1
		"blue", // 2
		"lightPurple", // 3
		"royalblue", // 4
		"green", // 5
		"lightPink", // 6
		"purple", // 7
		"teal", // 8
	];
};

module.exports = {
	getContiguousSections,
	getPartitionedGrid,
	getValueColors,
};
